module.exports = __webpack_public_path__ + "static/media/ipad-whatWeDo.03c80b89.mp4";